import { React, ts } from '_core';

import Chart from './chart';

type RiskModelMedianAnnualizedVolatilityVsTimeProps = {
  id: string;
  readOnly: boolean;
  widgetKey: string;
  mode: ts.enums.CHART_MODE_ENUM;
  title: string;

  fullScreen?: boolean;
  loadWidgetData: (_payload: ts.types.widgets.WidgetGetDataParams) => Promise<ts.types.widgets.WidgetGetDataResponse>;
  widgetPaths?: Record<'median_annualized_volatility', string>;
};

const RiskModelMedianAnnualizedVolatilityVsTime = ({
  id,
  readOnly,
  widgetKey,
  loadWidgetData,
  widgetPaths,
  fullScreen,
  title,
}: RiskModelMedianAnnualizedVolatilityVsTimeProps) => {
  return (
    <Chart
      id={id}
      readOnly={readOnly}
      widgetKey={widgetKey}
      loadWidgetData={loadWidgetData}
      volatility={widgetPaths['median_annualized_volatility']}
      fullScreen={fullScreen}
      title={title}
    />
  );
};

export default RiskModelMedianAnnualizedVolatilityVsTime;
